import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "UploadFile",
  class: "ImporterRow"
}
const _hoisted_2 = { class: "ImporterField" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("label", {
      class: "ImporterLabel",
      for: "UploadButton"
    }, " Selected file ", -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "file",
        ref: "uploadButton",
        class: "UploadButton",
        accept: ".csv",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.processUpload && _ctx.processUpload(...args)))
      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */)
    ])
  ]))
}